export default __webpack_public_path__ + "static/media/g2022-31.ebbb7438.jpeg";